module.exports = __webpack_public_path__ + "static/img/weaponbanner1.0caada7.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/weapon/weaponbanner1.png
// module id = 1YSf
// module chunks = 9